import { Typography } from 'components/typography';

import { SourceRow } from '../types';
import { shortSourceLabel } from '../utils/buildCalculationSteps';

type LowConfidenceNoticeProps = {
  sources: SourceRow[];
};

// Shown when every rate source was below the confidence threshold and Kit used them anyway.
export function LowConfidenceNotice({ sources }: LowConfidenceNoticeProps) {
  return (
    <div
      data-testid='kit-coach-low-confidence'
      className='mt-2 w-full rounded border border-warning-200 bg-warning-50 px-2 py-1.5'
      role='status'
    >
      <Typography variant='body-xxs' className='text-neutral-800'>
        {lowConfidenceMessage(sources)}
      </Typography>
    </div>
  );
}

function lowConfidenceMessage(sources: SourceRow[]): string {
  const [onlySource] = sources;
  if (sources.length === 1 && typeof onlySource.confidenceLevel === 'number') {
    return `Based on ${shortSourceLabel(onlySource.label)} only (${onlySource.confidenceLevel}% confidence). Treat as a starting point.`;
  }

  return 'Based only on low-confidence sources. Treat as a starting point.';
}
